import JodiReportBetsTable from "../../admin/JodiReportBets/Index";

const OperatorJodiReportBets = () => (
  <JodiReportBetsTable basePath="/operator" />
);

export default OperatorJodiReportBets;
